import React from "react";
import { withTranslation } from "react-i18next";
import { splitClientUsersByRole } from "../helpers/clientUsersByRole";

const ROLE_SECTIONS = [
  {
    key: "fleetManagers",
    titleKey: "ClientManagementScreenContent.FleetManagers",
    icon: "fa-user",
  },
  {
    key: "superintendents",
    titleKey: "ClientManagementScreenContent.TechnicalSuperintendents",
    icon: "fa-user-md",
  },
  {
    key: "technicalExecutives",
    titleKey: "ClientContactUserManagementContent.TE",
    icon: "fa-user-o",
  },
];

class ClientContactUsersReadOnly extends React.Component {
  renderUserRow(user) {
    return (
      <div
        key={user.clientUserId || `${user.email}-${user.userName}`}
        className="um-client-user-readonly-row"
      >
        <div className="um-client-user-readonly-cell um-client-user-readonly-cell-name">
          <span className="um-client-user-readonly-mobile-label">
            <i className="fa fa-user" aria-hidden="true"></i>
          </span>
          <span className="um-client-user-readonly-value" title={user.userName || ""}>
            {user.userName || "-"}
          </span>
        </div>
        <div className="um-client-user-readonly-cell um-client-user-readonly-cell-email">
          <span className="um-client-user-readonly-mobile-label">
            <i className="fa fa-envelope-o" aria-hidden="true"></i>
          </span>
          <span className="um-client-user-readonly-value" title={user.email || ""}>
            {user.email || "-"}
          </span>
        </div>
        <div className="um-client-user-readonly-cell um-client-user-readonly-cell-phone">
          <span className="um-client-user-readonly-mobile-label">
            <i className="fa fa-phone" aria-hidden="true"></i>
          </span>
          <span className="um-client-user-readonly-value">{user.telephone || "-"}</span>
        </div>
      </div>
    );
  }

  renderRoleSection(section, users, t) {
    return (
      <div key={section.key} className="um-section um-client-users-section">
        <div className="um-section-header">
          <h5 className="um-section-title">
            <i className={`fa ${section.icon} um-section-title-icon`} aria-hidden="true"></i>
            {t(section.titleKey)}
          </h5>
        </div>
        <div className="um-section-body">
          {users.length ? (
            <div className="um-client-user-readonly-table">
              <div className="um-client-user-readonly-header" aria-hidden="true">
                <div className="um-client-user-readonly-header-cell">
                  <i className="fa fa-user um-list-label-icon" aria-hidden="true"></i>
                  <span>{t("EquipmentManagementScreenContent.Name")}</span>
                </div>
                <div className="um-client-user-readonly-header-cell">
                  <i className="fa fa-envelope-o um-list-label-icon" aria-hidden="true"></i>
                  <span>{t("ServicedByScreenContent.Email")}</span>
                </div>
                <div className="um-client-user-readonly-header-cell">
                  <i className="fa fa-phone um-list-label-icon" aria-hidden="true"></i>
                  <span>{t("ClientManagementScreenContent.Phone")}</span>
                </div>
              </div>
              <div className="um-client-users-readonly-list">
                {users.map((user) => this.renderUserRow(user))}
              </div>
            </div>
          ) : (
            <div className="um-client-users-empty">{t("ClientManagementScreenContent.NoUsers")}</div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { users, t, loading } = this.props;
    const grouped = splitClientUsersByRole(users);

    if (loading) {
      return (
        <div className="um-client-contact-users-readonly um-client-users-loading">
          Loading...
        </div>
      );
    }

    return (
      <div className="um-client-contact-users-readonly um-client-users-readonly">
        {ROLE_SECTIONS.map((section) =>
          this.renderRoleSection(section, grouped[section.key] || [], t)
        )}
      </div>
    );
  }
}

export default withTranslation()(ClientContactUsersReadOnly);
